module.exports = __webpack_public_path__ + "static/promo-right-01509ce4288de1a14b8622e2ad777b5b.png";